define('fukit/controller/base.controller',['require','exports','module','underscore','marionette','backbone','appkit/appkit','../model/base.model','../collection/base.collection','datakit/datakit','../helpers/roles.helper','../helpers/error.util','../config','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _                            = require('underscore'),
      Mn                           = require('marionette'),
      Backbone                     = require('backbone'),
      AppKit                       = require('appkit/appkit'),
      BaseModel                    = require('../model/base.model'),
      BaseCollection               = require('../collection/base.collection'),
      DataKit                      = require('datakit/datakit'),
      RolesHelper                  = require('../helpers/roles.helper'),
      ErrorUtil                    = require('../helpers/error.util'),
      ENABLE_ACTIVE_PRODUCT_CHECKS = require('../config').get('ENABLE_ACTIVE_PRODUCT_CHECKS'),
      Radio                        = require('backbone.radio');

  var BaseController = AppKit.Controller.extend({
    fallbackFragment: null,

    resourceDefaults: { required: true },

    constructor: function() {
      AppKit.Controller.apply(this, arguments);
      this.once('before:start', this._baseOnBeforeStart, this);
      // add custom event handlers here
      this.on('start', this._baseOnStart, this);
    },

    initialize: function() {
      AppKit.Controller.prototype.initialize.apply(this, arguments);
      this.registerStartInterceptor(this.permissionDeniedInterceptor, this);
      if (ENABLE_ACTIVE_PRODUCT_CHECKS) {
        this.registerStartInterceptor(this.productDeactivatedInterceptor, this);
      }

      // Set a listener for when the pageView is attached to the DOM.  When this happens,
      // we attempt to harvest the header text from the PageHeaderView to serve as a page title.
      // We then update the accessibility announcement live region with text mimicking that of
      // a page load so the new page will be read to assistive technologies.
      this.listenTo(this.page, 'attach', function(view) {
        var pageTitle =
          _.property('root.pageHeader.headerText')(view) || _.property('root.pageHeader.header.text')(view) || ''; //Using .property here in case the property we seek does not exist
        Radio.channel('App.A11y').request('announce', pageTitle + ' page loaded', 'assertive');
      });
    },

    permissionDeniedInterceptor: function(controller) {
      var acceptedRoles = controller.state.get('roles');

      if (!RolesHelper.getUserRoles()) {
        throw new Error('User access roles do not appear to have been assigned');
      }

      if (!acceptedRoles || _.isEmpty(acceptedRoles)) {
        return;
      }

      var canAccessPage = RolesHelper.evaluateRoleArrayAgainstUserRoles(acceptedRoles);

      this.throwPermissionErrorIfFalse(canAccessPage);
    },

    productDeactivatedInterceptor: function(controller) {
      var requiredActiveProducts = controller.state.get('requiredActiveProducts');
      var enabledProductCollection;
      var isProductRequirementMet;
      if (requiredActiveProducts) {
        enabledProductCollection = Radio.request('AppKit.resourceService', 'resource', 'enabledProductCollection');
        isProductRequirementMet = enabledProductCollection.any(function(activeProduct) {
          return _.contains(requiredActiveProducts, activeProduct.get('name')) && activeProduct.get('active');
        });

        this.throwProductDeactivatedErrorIfFalse(isProductRequirementMet);
      }
    },

    throwPermissionErrorIfFalse: function(value) {
      if (!value) {
        throw new ErrorUtil.PermissionError('Access Denied');
      }
    },

    throwProductDeactivatedErrorIfFalse: function(value) {
      if (!value) {
        throw new ErrorUtil.ProductDeactivatedError('Product Deactivated');
      }
    },

    onResourceInitialize: function(self, resource, options) {
      // If the resource is a FormKit template object (as indicated by the flag given at definition),
      // let's register it with the resource service so other things in the app can retrieve it easily
      if (options.resourceDefinition && options.resourceDefinition.isFormTemplateModel) {
        Radio.request('AppKit.resourceService', 'registerResource', 'formTemplateModel', resource);
      }

      if (resource instanceof BaseModel) {
        resource.enableUnsavedChangesEvent();
      }

      if (resource instanceof BaseCollection) {
        // detect if a collection is using the traditional search API, and if so apply
        // defined filters.
        if (resource.filters instanceof Backbone.Collection) {
          resource.filters.add(this.resolveFilters(options.resourceDefinition));
        }

        if (options.resourceDefinition.sort) {
          var sort = resource.sort.field(options.resourceDefinition.sort.field);
          if (options.resourceDefinition.sort.direction == 'descending') {
            sort.makeDescending();
          } else {
            sort.makeAscending();
          }
        }
      }

      if (options.resourceDefinition.paginate) {
        if (options.resourceDefinition.paginate.size) {
          resource.paginate.size(options.resourceDefinition.paginate.size);
        }
      }

      if (resource instanceof DataKit.Collection) {
        resource.urlParams(this.resolveUrlParams(options.resourceDefinition));
      }
    },

    _baseOnBeforeStart: function() {},

    _baseOnStart: function() {},

    resolveFilters: function(resourceDefinition) {
      return _.map(
        resourceDefinition.filters,
        function(unresolvedFilter) {
          if (!this.resolveObjectWithStateVariables) {
            return;
          }

          return this.resolveObjectWithStateVariables(unresolvedFilter);
        },
        this
      );
    },

    resolveUrlParams: function(resourceDefinition) {
      if (_.isFunction(resourceDefinition.urlParams)) {
        return Mn._getValue(resourceDefinition.urlParams, this);
      } else {
        return this.resolveObjectWithStateVariables(resourceDefinition.urlParams);
      }
    },
  });

  module.exports = BaseController;
});

